<div class="d-flex container-fluid flex-column h-100 py-3">
  <div class="carousel-container">
    <ngb-carousel
      #carousel
      [interval]="3000"
      [showNavigationArrows]="true"
      [wrap]="true"
      (slide)="onCarouselSlide($event)"
    >
      <ng-template
        ngbSlide
        *ngFor="let slide of slides; let i = index"
        [id]="overview[i].name"
      >
        <div class="carousel-slide">
          <img [src]="slide" [alt]="overview[i].name + ' overview'" />
        </div>
      </ng-template>
    </ngb-carousel>
  </div>

  <div class="btn-wrapper">
    <div
      class="d-flex justify-content-between align-items-center mt-4 sub-card"
    >
      @for(section of overview; track section.name) {
      <div
        class="cursor-pointer d-flex btn-accello-cards"
        [class.active]="isExpanded(section.name)"
        (click)="toggleSection(section.name)"
        (keydown)="toggleSection(section.name)"
      >
        <img
          src="assets/images/virtusa-icons/{{ section.name }}.svg"
          alt="add"
        />
        {{ section.name }}
      </div>
      }
    </div>
  </div>
</div>
